import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/PlaySection.css';

const PlaySection = () => {
  const { t, i18n } = useTranslation();
  
  // 获取移动端显示的标题文本
  const getMobileTitle = () => {
    return i18n.language === 'zh' ? "欢迎你回家" : "Welcome you home";
  };
  
  return (
    <section className="play-section">
      <h2 className="play-title play-title-mobile">{getMobileTitle()}</h2>
      <div className="play-image-container">
        <div className="play-image" style={{ backgroundImage: 'url(/images/page10.png)' }}>
          <h2 className="play-title play-title-desktop">{t('companion.welcomeHome')}</h2>
          <div className="play-content">
            <p className="play-subtitle">
              {t('companion.wheneverNeed')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlaySection; 